import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlink = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-unlink-icon lucide-unlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71" }),
		/* @__PURE__ */ _jsx("path", { d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 8,
			x2: 8,
			y1: 2,
			y2: 5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 2,
			x2: 5,
			y1: 8,
			y2: 8
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			x2: 16,
			y1: 19,
			y2: 22
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			x2: 22,
			y1: 16,
			y2: 16
		})
	]
});
export default SvgUnlink;
